module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-11.40a3d118.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-11.jpg
// module id = 1897
// module chunks = 2